<app-entity-complaints [entityType]="sharedService.serviceCenter"></app-entity-complaints>
